import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SiteComponent } from './site.component';
import { SiteHomeModule } from "./site-home/site-home.module";
import { SiteOperationsModule } from './site-operations/site-operations.module';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SiteHomeModule,
    SiteOperationsModule
  ],
  declarations: [SiteComponent],
  exports: [
    SiteComponent
  ]
})
export class SiteModule { }
